<template>
  <material-card
  :title="$t('views.portal.icons')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="palette"
  >
    <edit-images></edit-images>
  </material-card>
</template>
<script>
import EditImages from "../components/EditImages";
export default {
  components: {
    EditImages,
  },
};
</script>
